import { default as thumbnailGenerator, namespace as thumbnailGeneratorNamespace } from './modules/thumbnail-generator'

const namespaced = true
const namespace = 'ThumbnailGenerator'

const modules = {
    [thumbnailGeneratorNamespace]: thumbnailGenerator,
}

export {namespaced, namespace, modules}
